import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule, Router } from '@angular/router';
import { AppComponent } from './app.component';
import { Error404Component } from './modules/error404/index';
import { SharedService } from './modules/shared/service/shared.service';
import { SharedModule } from './modules/shared/shared.module';
import { TokenInterceptorService } from './token-interceptor.service';
import { AuthenticationService } from './_services/authentication.service';
import { CommonFunctionsService, EncrDecrService, UserService } from './_services/index';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PlanAuthGuard,RecruiterAuthGuard,JobseekerAuthGuard,ResumeWriterAuthGuard} from './guards/index';
import { Injector, APP_INITIALIZER } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common'; 
import { appInitializerFactory } from './translate_language';
import { environment } from '../environments/environment';
import { ProgressbarModule,ProgressbarConfig } from 'ngx-bootstrap/progressbar';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient): any {
	return new TranslateHttpLoader(httpClient,environment.SITE_URL+"assets/i18n/", ".json?time="+Date.now());
}      	   
@NgModule({              
	declarations: [           
		AppComponent,                       
		Error404Component
	],        
	imports: [    
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		BrowserAnimationsModule,
		CommonModule,
		AppRoutingModule,
		HttpClientModule,  
		SharedModule, 
		FormsModule,  
		ProgressbarModule.forRoot(), 
		ToastrModule.forRoot({
			closeButton: true, 
			 enableHtml: true
	     }),    
		ReactiveFormsModule,   
		
		TranslateModule.forRoot({        
			loader: { 
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory, 
				deps: [HttpClient]
			} 
		})           
	],              
	providers: [
		{ 
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptorService,
			multi: true
		}, 
		{
			provide: APP_INITIALIZER,
			useFactory: appInitializerFactory,
			deps: [TranslateService, Injector],
			multi: true
		},
		SharedService,
		CommonFunctionsService,          
		UserService,   
		AuthenticationService,    
		EncrDecrService,
		PlanAuthGuard,
		RecruiterAuthGuard,
		JobseekerAuthGuard,
		ResumeWriterAuthGuard
	],    
	exports: [CommonModule],  
	bootstrap: [AppComponent]   
})
export class AppModule {}   
   
           
